import type { CdaDocument, CdaDocumentErrorCode } from '@ctw/shared/utils/cda/types';

export type { CdaDocumentErrorCode } from '@ctw/shared/utils/cda/types';

/**
 * Plain-text messages for the PDF render paths (client `PdfCdaRenderer` and the
 * server-side cover page), which cannot render a clickable support link. The
 * React viewer renders its own equivalents with a `SupportFormLink`.
 */
export const cdaDocumentPdfErrorMessages: Record<CdaDocumentErrorCode, string> = {
  'no-content': 'There is no content available to display for this document.',
  'fetch-failure': 'Unable to load this document. If this problem persists, contact support.',
  'parse-error':
    'This document cannot be shown due to invalid XML. Download the XML to view the document.',
  'too-large': 'This document is too large to display. Download the original document to view it.',
};

/**
 * Classifies a `CdaDocument`'s document-level failure from its stable
 * `parseError.code`. Returns `undefined` when the document has no document-level
 * `parseError` (individual sections may still carry their own `parseError`); a
 * document-level error with no recognized code is treated as a genuine
 * `parse-error`.
 *
 * Detection keys on the code ONLY — never on the (presentational) `message`.
 */
export const classifyCdaDocumentError = (
  cdaDocument: CdaDocument,
): CdaDocumentErrorCode | undefined =>
  cdaDocument.parseError ? (cdaDocument.parseError.code ?? 'parse-error') : undefined;
